import { ControllerFieldState, FieldValues, FormState } from 'react-hook-form';

export const shouldShowFieldError = (
  fieldState: ControllerFieldState,
  formState: FormState<FieldValues>
) => {
  return fieldState.error && (fieldState.isTouched || formState.isSubmitted);
};
